import { OdooAuthError } from "@/api/odooAuthClient";
import { OdooStatementError } from "@/api/odooStatementClient";

function statusOf(error) {
  if (error instanceof OdooAuthError || error instanceof OdooStatementError) {
    return error.status;
  }
  return null;
}

export function formatOdooError(error, messages) {
  const status = statusOf(error);
  if (status === 403) return messages.forbidden;
  if (status === 401) return messages.unauthorized;
  if (error instanceof TypeError) return messages.network;
  if (error instanceof Error && error.message.trim()) return error.message;
  return messages.generic;
}

export function isOdooUnauthorized(error) {
  return statusOf(error) === 401;
}
